import { Button, Card, Col, Row } from "reactstrap";
import IconInput from "../../components/inputs/IconInput";
import { Link, useNavigate } from "react-router-dom";
import useAuthHooks from "../../hooks/useAuthHooks";
import ErrorModal from "../../components/modals/ErrorModal";
import { appString } from "../../utils/appString";
import { IoLockClosed } from "react-icons/io5";
import { AuthHalfScreenComp } from "../../components/commonComponents";
import { useTranslation } from "../../languages";

export const ResetPassword = () => {
  const {
    //all local states
    resetCreditionals,
    setResetCreditionals,

    //all functions
    onPressResetSubmitBtn,
  } = useAuthHooks();

  //all navigate
  const navigateTo = useNavigate();

  //all functions
  const onToggleSuccessModal = () => {
    setResetCreditionals((prev) => ({ ...prev, successMessage: "" }));
  };
  const { t } = useTranslation();

  return (
    <Row className="full-screen m-0">
      <AuthHalfScreenComp />
      <Col
        md={6}
        lg={5}
        className="d-flex py-3 align-items-center justify-content-center"
      >
        <Card className="bg-transparent border-none full-width mx-xl-5 mx-4">
          <h4 className="f-7"> {t("resetPasswordTitle")}</h4>
          <h5 className="f-4 m-0">{t("enterNewPassword")}</h5>
          <div className="mt-4 mb-3">
            <IconInput
              Icon={IoLockClosed}
              className={"mb-3"}
              placeholder={"Password"}
              value={resetCreditionals?.password}
              setValue={(e) =>
                setResetCreditionals((prev) => ({ ...prev, password: e }))
              }
            />
          </div>

          <Button
            onClick={onPressResetSubmitBtn}
            className="standard-rounded-btn  py-3 mb-2 full-width"
          >
            {t("submit")}
          </Button>

          <div className="d-flex gap-2 mb-5 justify-content-center align-items-center flex-wrap">
            <span className="color-half-black">{t("backToLogin")}</span>
            <Link to={"/login"} className="text-black text-decoration-none">
              {t("login")}
            </Link>
          </div>
        </Card>
      </Col>
      <ErrorModal
        isOpen={resetCreditionals?.error}
        toggle={() => setResetCreditionals((prev) => ({ ...prev, error: "" }))}
        errorMessage={resetCreditionals?.error}
      />

      <ErrorModal
        isOpen={resetCreditionals?.successMessage}
        success={true}
        toggle={onToggleSuccessModal}
        onConfirm={() => {
          navigateTo("/login");
        }}
        errorMessage={resetCreditionals?.successMessage}
      />
    </Row>
  );
};
